import React from 'react';
import {view, Icon} from '@sail/ui';
import {warning, warningCircle} from '@sail/icons/react/Icon';
import {Text} from 'src/v2/components/common/Text';

type BannerVariant = 'error' | 'warning';

interface BannerProps {
  message: React.ReactNode;
  variant?: BannerVariant;
}

const variantConfig = {
  error: {
    icon: warningCircle,
    backgroundColor: 'feedback.critical.subdued',
    iconColor: 'feedback.critical',
  },
  warning: {
    icon: warning,
    backgroundColor: 'feedback.attention.subdued',
    iconColor: 'onFeedback.attention',
  },
};

export const Banner: React.FC<BannerProps> = ({message, variant = 'error'}) => {
  const config = variantConfig[variant];

  return (
    <view.div
      css={{
        stack: 'x',
        padding: 'space.150',
        borderRadius: 'small',
        backgroundColor: config.backgroundColor,
        alignItems: 'flex-start',
        gap: 'space.150',
      }}
    >
      <Icon
        icon={config.icon}
        css={{
          color: config.iconColor,
          flexShrink: 0,
          height: 'space.150',
          width: 'space.150',
          marginTop: '3px',
        }}
      />

      <Text type="caption">{message}</Text>
    </view.div>
  );
};
